import React from 'react';
import PropTypes from 'prop-types';

import Heading4 from '../../common/Heading4';
import Heading2 from '../../common/Heading2';
import Locale from '../../Translate/Locale';
import Text from '../../common/Text';
import DrawerHeader from '../drawer/DrawerHeader';
import IconButton from '../IconButton';

import CloseIcon from '../../../icons/close.svg';

import './SidePanelHeader.scss';

function SidePanelHeader(props) {
  const { onClose, subHeading, heading, leftElement } = props;

  const Heading = subHeading ? Heading4 : Heading2;

  return (
    <DrawerHeader>
      <div styleName="left-element">{leftElement}</div>
      <div styleName="heading">
        <Heading>{heading}</Heading>
        {subHeading && (
          <Text small>
            <Locale>{subHeading}</Locale>
          </Text>
        )}
      </div>
      <div styleName="right-element">
        <IconButton icon={CloseIcon} ariaLabel="Close" onClick={onClose} />
      </div>
    </DrawerHeader>
  );
}

SidePanelHeader.propTypes = {
  onClose: PropTypes.func,
  heading: PropTypes.string,
  subHeading: PropTypes.string,
};

export default React.memo(SidePanelHeader);
